module.exports = __webpack_public_path__ + "static/img/LAZY-AIR.b1fc6f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/LAZY-AIR.jpg
// module id = iATP
// module chunks = 1